import React from 'react';
import { Icon } from './Icon.js';
export const IconExternalLink = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M4.99991 21L14.9999 11L14.5 11.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M9 11H15V17", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M21 23H7.24414L9.24414 21H19V3H5V16.7598L3 18.7598V1H21V23Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconExternalLink.js.map